const locale = {
  placeholder: 'Vybrat Äas',
};

export default locale;
